import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Button, Card, CardBody, CardFooter, CardHeader, FormField, Image, List, Text, TextInput } from "grommet";
import { debounce } from "lodash";
import React from "react";
import Avatar from "react-avatar";
import { AliasViewModel, searchAliases } from "../aliases/AliasStore";
import OrganizationSearch from "../organizations/OrganizationSearch";
import { Organization } from "../organizations/OrganizationStore";
import { AwardBadge, BadgeViewModel, GetBadge } from "./BadgeStore";
import { useParams } from "react-router-dom";
import { format, parseJSON } from "date-fns";

export const AwardBadges = () => {
    const [badge, setBadge] = React.useState({} as BadgeViewModel);
    const { id } = useParams<{ id: string }>();

    React.useEffect(() => {
        if (id) {
            GetBadge(id).then((response) => {
                setBadge(response.result);
            });
        }
    }, [id]);

    let [organization, setOrganization] = React.useState({} as Organization);

    let [userSearchResult, setUserSearchResult] = React.useState([] as Array<AliasViewModel>);

    const search = (filter, organizationID) => {
        searchAliases(filter, organizationID, 0, 10).then((response) => {
            setUserSearchResult(response);
        });
    };

    const debounceSearch = React.useMemo(() => debounce(search, 300), []);

    let [userFilter, setUserFilter] = React.useState("");

    const [badgeAwardError, setBadgeAwardError] = React.useState("");

    React.useEffect(() => {
        debounceSearch(userFilter, organization.id);
    }, [userFilter, organization.id]);

    const awardBadge = (alias: AliasViewModel) => {
        setBadgeAwardError("");

        AwardBadge(badge.id, alias.id).then((response) => {
            if (response.success) {
            } else {
                setBadgeAwardError(response.errors.join("\n"));
            }
        });
    };

    return (
        <>
            <OrganizationSearch onSelect={(organization) => setOrganization(organization)}></OrganizationSearch>
            <FormField label="Search">
                <TextInput size="xs" value={userFilter} onChange={(e) => setUserFilter(e.target.value)} />
            </FormField>
            <List
                pad="xs"
                data={userSearchResult}
                itemKey="id"
                primaryKey={(alias: AliasViewModel) => (
                    <Text size="small" key={alias.id}>
                        <Avatar name={alias.name} src={alias.photoUri} round size="25px"></Avatar> {alias.name}
                    </Text>
                )}
                action={(item, index) => {
                    let currentBadge = item.badges.find((b) => b.badgeID == badge.id);

                    if (currentBadge) {
                        return <Text>Awarded on {format(parseJSON(currentBadge.awardedOn), "yyyy/MM/dd")}</Text>;
                    } else {
                        return <Button hoverIndicator key={item.id} size="small" secondary onClick={() => awardBadge(item)} icon={<FontAwesomeIcon icon={["fad", "caret-right"]}></FontAwesomeIcon>} />;
                    }
                }}
            ></List>
            <Text>
                <pre>{badgeAwardError}</pre>
            </Text>
        </>
    );
};
